import * as React from 'react';

import { ShowMoreGridSection } from '@coursera-web/cds-labs';

import { Grid, PageGridContainer, Typography2, breakpoints, useMediaQuery } from '@coursera/cds-core';

import { useEnterpriseLearningPathPageData } from 'bundles/enterprise-learning-path-description-page/contexts/EnterpriseLearningPathContext';
import { SKILL_PATHWAY_NAV_ITEMS } from 'bundles/enterprise-learning-path-description-page/utils/getPageNavigationLinks';
import EnterpriseLearningPathProductCard from 'bundles/page-config-common/components/enterprise/EnterpriseLearningPathProductCard';
import { useEnterpriseBadgeCollections } from 'bundles/page-config-common/contexts/enterprise/EnterpriseBadgeCollectionsContext';
import Section from 'bundles/unified-description-page-common/components/shared/Section';
import { useEnterpriseAllSkillPathways } from 'bundles/unified-home-common/contexts/enterprise/EnterpriseAllSkillPathwaysContext';

import _t from 'i18n!nls/enterprise-learning-path-description-page';

const Recommendations = () => {
  const { skillPathways } = useEnterpriseAllSkillPathways();
  const { enterpriseBadgesWithCollection } = useEnterpriseBadgeCollections();
  const pageData = useEnterpriseLearningPathPageData();
  const isMobile = useMediaQuery(breakpoints.down('sm'));

  const currentPageBadgeId = pageData?.enterpriseBadge?.id;

  const badgesToDisplay = React.useMemo(() => {
    return enterpriseBadgesWithCollection.filter((badge) => {
      if (badge.enterpriseBadge.badgeTemplateId === currentPageBadgeId) {
        return false;
      }
      return skillPathways?.some(
        (skillPathway) => skillPathway.badgeTemplateId === badge.enterpriseBadge.badgeTemplateId
      );
    });
  }, [enterpriseBadgesWithCollection, skillPathways, currentPageBadgeId]);

  if (badgesToDisplay.length === 0) {
    return null;
  }

  const defaultRows = isMobile ? 2 : 1;

  return (
    <Section anchorId={SKILL_PATHWAY_NAV_ITEMS.RECOMMENDATIONS} spacing={8}>
      <PageGridContainer>
        <Grid item xs={12}>
          <ShowMoreGridSection
            renderTitle={() => (
              <Typography2 component="h3" variant="subtitleLarge">
                {_t('You might also like')}
              </Typography2>
            )}
            defaultRows={defaultRows}
            spacing={{ sm: 24, xs: 16 }}
            items={badgesToDisplay}
            renderItem={({ item: badge, itemIndex }) => (
              <EnterpriseLearningPathProductCard
                enterpriseBadgeWithCollection={badge}
                itemIndex={itemIndex}
                isSkillPathway={true}
              />
            )}
          />
        </Grid>
      </PageGridContainer>
    </Section>
  );
};

export default Recommendations;
